module.exports = __webpack_public_path__ + "static/media/greyCancel.727e4672.svg";